import clsx from 'clsx';

function rel(d: Date) {
  const diff = (Date.now() - d.getTime()) / 1000;
  if (diff < 60) return 'just now';
  if (diff < 3600) return `${Math.floor(diff/60)}m`;
  if (diff < 86400) return `${Math.floor(diff/3600)}h`;
  if (diff < 86400*7) return `${Math.floor(diff/86400)}d`;
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
}

export function Timestamp({ date, className }: { date: Date | string; className?: string }) {
  const d = typeof date === 'string' ? new Date(date) : date;
  return <span className={clsx('text-xs text-muted tnum', className)} title={d.toLocaleString()}>{rel(d)}</span>;
}
